/* Site-Specific JavaScript */
jq(document).ready(function() {
    // FAQ accordion: enforce single-open behavior — opening one panel closes any
    // other open panel within the same .faqs-accordion__items group. Clicking an
    // already-open panel still toggles it closed.
    jq('.faqs-accordion__items').on('show.bs.collapse', '.faqs-accordion__panel', function() {
        jq(this)
            .closest('.faqs-accordion__items')
            .find('.faqs-accordion__panel.show')
            .not(this)
            .collapse('hide');
    });

    // Home hero: avoid flash before video plays — fade in video only after it starts
    jq('#page-banner-video-desktop, #page-banner-video-mobile').each(function() {
        var video = this;
        var fullscreenBg = jq(video).closest('.fullscreen-bg');
        if (!fullscreenBg.length) return;
        function markReady() {
            fullscreenBg.addClass('video-ready');
            video.removeAttribute('poster');
        }
        if (video.readyState >= 2) {
            markReady();
        } else {
            jq(video).one('playing', markReady);
        }
    });
    jq('h2, h3, .stat--title, th, .key-terms__card-title').each(function() {
        var text = jq(this).html();

        // Use regex to match {{number}} patterns
        var newText = text.replace(/\{\{(\d+)\}\}/g, function(match, number) {
            return '<sup>' + number + '</sup>';
        });

        // Update the h2 content with the new text
        jq(this).html(newText);
    });
});


const selector = document.getElementById("class-type");
const metrics = document.querySelectorAll(".metric-box");
const panels = document.querySelectorAll(".data-panel");

const togglePanel = (panel) => {
    const selectMetric = document.getElementById("metric-"+ panel);
    const selectPanel = document.getElementById("panel-" + panel);

    if (metrics) {
        metrics.forEach((panel) => {
            panel.classList.remove("active");
        });    
    }
    if (panels) {
        panels.forEach((panel) => {
            panel.classList.remove("active");
        });    
    }

    if (selectMetric) selectMetric.classList.toggle("active");
    if (selectPanel) selectPanel.classList.toggle("active");

    if (typeof jq !== 'undefined' && jq.fn.matchHeight) {
        jq.fn.matchHeight._update();
    }
};

if (selector) {
    selector.addEventListener("change", (event) => {
        const selected = event.target.value;
        togglePanel(selected);
    });
}


//State Popup
//Modified to use current eqDialog library for accessibility
var $statePopup = jq('#statePopup');
var statePopupCookieName = "eqStateAnnouncement";

if ($statePopup.length) {
    var statePopupCookie = Cookies.get(statePopupCookieName);
    if (!statePopupCookie) {
        const eqDialog = new EqDialog();

        // Open the dialog and retrieve the dialog element
        const dialog = eqDialog.open('inline', 'statePopup', '', 'Close Important Notice');
        const $dialog = jq(dialog);

        // Set up a click event listener on the submit button within the dialog
        $dialog.on('click', '.submit-btn', function() {
            const selectField = $dialog.find('select');
            let stateValue = selectField.val();
            if (stateValue !== '0') {
                if (stateValue == 'All Other U.S. States') {
                    window.location.href = "https://www.antares.com/";
                } else {
                    // Set the cookie with the selected state value
                    Cookies.set(statePopupCookieName, stateValue, { secure: true, domain: window.location.hostname, expires: 1 });
    
                    // Close the dialog
                    dialog.close();
    
                    // Reload the page
                    document.location.reload();
                }
            } else {
                alert('Please fill out all fields');
            }
        });
    }
}
    
function validate_forms() {
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") == "radio") {
                    error.prependTo(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form 
            invalidHandler: function(event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                    errorElement.focus();
                }
            }
        });
    });
}
function setUniformButtonWidths() {
  const buttons = document.querySelectorAll(".module-asset-list .asset a.btn");

  // Find the maximum width using getBoundingClientRect
  let maxWidth = 0;
  buttons.forEach(btn => {
    const btnWidth = btn.getBoundingClientRect().width;
    maxWidth = Math.max(maxWidth, btnWidth);
  });

  // Apply the maximum width to all buttons
  buttons.forEach(btn => {
    btn.style.minWidth = `${maxWidth}px`;
  });
}

// Run after a longer delay to allow for rendering completion
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(setUniformButtonWidths, 300); // Delay set to 300 ms
});

// Adjust widths on window resize in case of layout shifts
window.addEventListener("resize", setUniformButtonWidths);

/**
 * Symbol footnotes (*, †, ‡, §, ¶).
 * Numbered footnotes are handled by EqFootnotes in 90-footnotes.js.
 */
document.addEventListener("DOMContentLoaded", function() {
    //Must use the custom-footnotes class
    if (!jq('.custom-footnotes').length > 0) return;
    
    // Common superscript symbols
    const superscriptSymbolRegex = /[*†‡§¶]/g;
    // Make sure to not accidentally select the footnotes superscripts
    const superscriptSelector = ".panel-collapse p sup, h2 sup, h3 sup, .stat--title sup, .page-banner p sup, .module:not(.footnotes) p sup, th sup"; 
    const footnoteSelector = ".footnotes sup";
    // Superscripts
    setTimeout(() => {
        superScriptFixerUpper()
    }, 1000);
    
    jq(window).resize(function(evt) {
        setTimeout(() => {
            superScriptFixerUpper();
        }, 100);
    });
    function endsWithChar(str, char) {
        return str.endsWith(char);
    }
    function superScriptFixerUpper(){
        var superscriptElements = document.querySelectorAll(superscriptSelector);
        var linkIds = [];
        var footnoteLinks = {};
        superscriptElements.forEach(function(element, index) {
            var elementText = element.textContent;
            if (element.querySelector('a') !== null) {
                // Already added superscript link
                return;
            }
            var footnoteLabel = getFootnoteLabel(elementText);
            if (!footnoteLabel) {
                return;
            }
            
            // Create link
            var link = document.createElement("a");
            link.href = "#footnote" + footnoteLabel;
            link.classList.add("footnote-anchor");
            let linkId = "footnote" + footnoteLabel + `${index}-ref`;
            if (!linkIds.includes(linkId)) {
                // Avoid duplicate id's 
                link.id = linkId;
                linkIds.push(linkId);
            }
            
            // Create <sup> if needed and add to link
            if (element.nodeName != "SUP") {
                var sup = document.createElement("sup");
                // Link will only be a number
                link.textContent = footnoteLabel;
                // Replace current symbol with new linked symbol
                element.textContent = elementText.replace(footnoteLabel,'');
            } else {
                // Sup but could contain symbols like (1) or 1.
                link.textContent = elementText;
                // Replace current symbol with new linked symbol
                element.textContent = elementText.replace(elementText,'');
            }
            
 
            if (element.nodeName != "SUP") {
                sup.appendChild(link);
                element.appendChild(sup);
            } else {
                element.appendChild(link);
            }
            // Store the link for later use with footnotes
            footnoteLinks[footnoteLabel] = link;
        });        
        
        // Process sup in footnotes
        var footnoteSupElements = document.querySelectorAll(footnoteSelector);
        footnoteSupElements.forEach(function(element, index) {
            var footnoteLabel = getFootnoteLabel(element.textContent);
            if (footnoteLinks[footnoteLabel]) {
                var backLink = document.createElement("a");
                backLink.href = "#" + footnoteLinks[footnoteLabel].id;
                // backLink.href = "#" + linkIds[index];
                backLink.id = "footnote" + footnoteLabel;
                backLink.textContent = element.textContent;
                backLink.setAttribute("aria-label","Back to reference " + footnoteLabel); 
                backLink.classList.add("footnote-return");
                element.innerHTML = '';
                element.appendChild(backLink);
    
                // Add id to the parent footnote element
                var footnoteElement = element.closest('.footnote');
                if (footnoteElement) {
                    footnoteElement.id = "footnote" + footnoteLabel;
                }
            }
        });
    }
    function extractNumber(text) {
        // Remove any non-digit characters and parse the result
        return parseInt(text.replace(/\D/g, ''));
    }
    function extractSuperscriptSymbol(text) {
        const superscriptSymbol = text.match(superscriptSymbolRegex);
        if (superscriptSymbol) {
            return superscriptSymbol[0];
        }
        return null;
    }
    function getFootnoteLabel(elementText) {
        // Get number or symbol from footnote reference
        let footnoteLabel = extractNumber(elementText);
    
        if (!footnoteLabel) {
        footnoteLabel = extractSuperscriptSymbol(elementText);
        }
        return footnoteLabel || null;
    }
});



// Footnote anchor scrolling is bound once by EqFootnotes (90-footnotes.js).